import { render, staticRenderFns } from "./poligons.pug?vue&type=template&id=20b3b1bc&lang=pug&external"
import script from "./poligons.js?vue&type=script&lang=js&external"
export * from "./poligons.js?vue&type=script&lang=js&external"
import style0 from "./poligons.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b3b1bc')) {
      api.createRecord('20b3b1bc', component.options)
    } else {
      api.reload('20b3b1bc', component.options)
    }
    module.hot.accept("./poligons.pug?vue&type=template&id=20b3b1bc&lang=pug&external", function () {
      api.rerender('20b3b1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/poligons/index.vue"
export default component.exports